import { get } from "lodash";
import { TableBody, TableRow, TableCell, cn } from "twyne-new.ui"

export default function TableResizeBody({ data, columns, rowClassName, keyField = 'id', rowWrapper }) {
  if (!data || !data.length) {
    return null
  }

  const RowWrapper = rowWrapper || TableRow
  return <>
    <TableBody>
      {data.map((row, rowIndex) => <RowWrapper
        className={cn(rowClassName && rowClassName(row), rowIndex % 2 && 'twy-bg-base')}
        key={row[keyField] || rowIndex}
        row={{ ...row, index: rowIndex }}
      >
        {columns.map(({ className, formatter, dataField }, colIndex) => <>
          <TableCell key={colIndex} className={className}>
            {formatter ? formatter(get(row, dataField), row, rowIndex) : get(row, dataField)}
          </TableCell>
        </>)}
      </RowWrapper>)}
    </TableBody>
  </>
}
